var map = {
	"./article-create.svg": 4906,
	"./article-ranking.svg": 9804,
	"./article.svg": 8414,
	"./change-theme.svg": 4357,
	"./chart.svg": 6132,
	"./close.svg": 8179,
	"./dashboard.svg": 4679,
	"./example.svg": 4030,
	"./exit-fullscreen.svg": 4861,
	"./eye-open.svg": 2429,
	"./eye.svg": 5628,
	"./fullscreen.svg": 6638,
	"./guide.svg": 7987,
	"./hamburger-closed.svg": 5367,
	"./hamburger-opened.svg": 6408,
	"./international.svg": 5091,
	"./introduce.svg": 3992,
	"./language.svg": 5247,
	"./link.svg": 1445,
	"./nested.svg": 5016,
	"./password.svg": 9902,
	"./permission.svg": 6212,
	"./personnel-info.svg": 3504,
	"./personnel-manage.svg": 3105,
	"./personnel.svg": 6595,
	"./reward.svg": 9380,
	"./role.svg": 3637,
	"./search.svg": 8217,
	"./table.svg": 4383,
	"./tree.svg": 2701,
	"./user.svg": 8848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;